import React from 'react';
import { Link } from 'react-router-dom';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
import { Paper } from '@material-ui/core'; 

import OrderModel from '../../../models/PickupOrderFwd';
import DoneIcon from '@material-ui/icons/CheckCircleOutlineOutlined';

import { truckStatusTime } from '../../../utils/truckStatusTime';
import { AttachFile } from '@material-ui/icons';

import commonStyles from '../../common/common.module.css';

const styles = (theme: Theme) =>

  createStyles({
    wrapper: {
      marginTop: '25px',
      paddingTop: '25px',
    },
    '@media (max-width: 480px)':{
      wrapper: {
        marginTop: '50px',
      }
    },
    doneIcon: {
      transform: 'scale(0.8)'
    },
    materialIcon: {
      transform: 'scale(0.8)'
    },
    statusClass: {
      display: 'flex',
      alignItems: 'center'
    }
  });

interface WhsOrderTableProps {
  classes: any;
  orders: OrderModel[];
  openAttachments: (data: OrderModel) => void;
};

const whsOrderTable = (props: WhsOrderTableProps) => {

  const { classes, orders } = props;

  return (
    <div className={ `${ commonStyles.wrapper } ${ classes.wrapper }` }>
      <h3 className={ `${ commonStyles.header }` }> Orders </h3>

      <MaterialTable

        components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}

        data={ orders } 

        columns={[
          { title: 'Order #', cellStyle: { cursor: 'pointer', color: '#003261', textDecoration: 'underline', paddingLeft: '2%', paddingRight: '2%'}, headerStyle: { paddingLeft: '2%', paddingRight: '2%'},
          render: (rowData: OrderModel) => {
            const type = rowData.order_type
            return <Link to={`/whs/${type}/${rowData.number}`} >{ rowData.number }{ (rowData as any).was_go === 'true' || (rowData as any).was_go === true ? ' (GO)' : '' }</Link>;
          }
          },
          { title: 'Trucker', field: 'delivery_company_name', cellStyle: {paddingLeft: '2%', paddingRight: '2%'}, headerStyle: { paddingLeft: '2%', paddingRight: '2%'}  },
          {
            title: 'Truck Status', 
            render: (rowData: OrderModel) => {
              const status = truckStatusTime(rowData);
              return rowData.truck_status.type === 0 ? <div className={ classes.statusClass }><DoneIcon className={ classes.doneIcon }></DoneIcon><span>{status}</span></div> : <div>{status}</div>
            }, 
            cellStyle: {paddingLeft: '2%', paddingRight: '2%'}, headerStyle: { paddingLeft: '2%', paddingRight: '2%'} 
          },
          { title: 'Dock', field: 'dock_name', cellStyle: {paddingLeft: '2%', paddingRight: '2%'}, headerStyle: { paddingLeft: '2%', paddingRight: '2%'}  },
          { 
            title: 'Action',
            render: (rowData: OrderModel) => {

              return <AttachFile className={  classes.materialIcon } onClick={ () => props.openAttachments(rowData) }/>;
            }
          }
        ]}

        options={{
          paging: false,
          pageSize: 10,
          headerStyle: {
            backgroundColor: 'var(--tbl_head_bkg)',
            color: 'var(--tbl_head_color)',
            zIndex: 2,
            },
          showTitle: false,
          pageSizeOptions: [15, 20],
          toolbar: false,
          sorting: false
        }}
      />
    </div>
  );
};

export default withStyles(styles)(whsOrderTable);